import React from "react";

export default function JS_Prototype() {
  return (
    <div className="tutorial-container">
      <h1>JS Prototype</h1>
      <p>
        This tutorial explains the concept of JS Prototype in JavaScript OOPs.
      </p>
    </div>
  );
}
